module.exports = __webpack_public_path__ + "img/device.55a9b27e.gif";